const UserFormPermissions = {
  ALLOW_DELETE_USERS: 'allow_delete_users',
};

export default UserFormPermissions;
